export function getCanvasSize(grid) {
  const maxW = window.innerWidth * 0.9;
  const maxH = window.innerHeight * 0.7;

  const ratio = grid.rows / grid.cols;

  let width = Math.min(750, maxW);
  let height = width * ratio;

  if (height > maxH) {
    height = maxH;
    width = height / ratio;
  }

  return { width, height };
}